import {handleData} from "./handleData";
export function getContentsOfURI(uri, id, type, timelineElement) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_contents_of_uri",
        datatype: "json",
        data: {
            "ajax_call_uri": uri,
            "ajax_call_id": id,
            "ajax_call_type": type
        },
        success: function (output) {
            handleData(output, timelineElement);
        }
    });
}